import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {
  WorkUpdate
} from "../../../education/components/Work Update/add-edit-work-update/add-edit-work-update.component";
import firebase from "firebase/compat/app";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CounsellingWorkUpdateService {
  env = isDevMode() ? environment.testMode : environment.productionMode;

  private collectionName = this.env.counsellingWorkUpdates;

  constructor(private afs: AngularFirestore,) {}

  addWorkUpdate(data: WorkUpdate) {
    const id = this.afs.createId();
    return this.afs.collection(this.collectionName).doc(id).set({
      ...data,
      id,
      createdAt: new Date()
    });
  }

  updateWorkUpdate(id: string, data: any) {
    return this.afs.collection(this.collectionName).doc(id).update(data);
  }

  deleteWorkUpdate(id: string) {
    return this.afs.collection(this.collectionName).doc(id).delete();
  }

  getAllWorkUpdates() {
    return this.afs.collection<WorkUpdate>(this.collectionName, ref =>
      ref.orderBy('date', 'desc')
    ).valueChanges();
  }

  getWorkUpdateById(id: string) {
    return this.afs.collection(this.collectionName).doc(id).valueChanges();
  }

  bulkChangeWorkUpdateData() {
    this.afs.firestore.collection(this.collectionName)
      .get()
      .then(snapshot => {

        const batch = this.afs.firestore.batch();

        snapshot.docs.forEach(doc => {

          const data: any = doc.data();
          const docRef = doc.ref;

          // Only migrate if centre field does NOT already exist
          if (!data.centre && (data.centreName || data.centreCode)) {

            let centreArray: any[] = [];

            // CASE 1: centreName & centreCode are arrays
            if (Array.isArray(data.centreName) && Array.isArray(data.centreCode)) {

              data.centreName.forEach((name: string, index: number) => {
                centreArray.push({
                  centreName: name || '',
                  centreCode: data.centreCode[index] || ''
                });
              });

            }
            // CASE 2: single string values (old structure)
            else {
              centreArray.push({
                centreName: data.centreName || '',
                centreCode: data.centreCode || ''
              });
            }

            batch.update(docRef, {
              centre: centreArray
            });

          }

        });

        return batch.commit();
      })
      .then(() => {
        console.log('Centre bulk migration completed successfully!');
      })
      .catch(error => {
        console.error('Error during centre bulk migration:', error);
      });
  }
}
